import { makeActionCreator } from '../../../utilities'
import { ExposureConstants } from './exposure.constants'

export const setExposureList = makeActionCreator(ExposureConstants.SET_EXPOSURE_LIST, 'exposureList')
export const setCrewList = makeActionCreator(ExposureConstants.SET_CREW_LIST, 'crewList')
export const setExposure = makeActionCreator(ExposureConstants.SET_EXPOSURE, 'exposure')
export const setCrewId = makeActionCreator(ExposureConstants.SET_CREW_ID, 'crewId')
export const setExposureEquipment = makeActionCreator(
  ExposureConstants.SET_EXPOSURE_EQUIPMENT,
  'exposureEquipment',
  'crewId'
)
export const setSuspectedExposure = makeActionCreator(
  ExposureConstants.SET_SUSPECTED_EXPOSURE,
  'suspectedExposure',
  'crewId'
)
export const setSuspectedExposurePNNV = makeActionCreator(
  ExposureConstants.SET_SUSPECTED_EXPOSURE_PNNV,
  'suspectedExposurePNNV',
  'crewId'
)
export const setExposureType = makeActionCreator(ExposureConstants.SET_EXPOSURE_TYPE, 'exposureType', 'crewId')
export const setExposureTypePNNV = makeActionCreator(ExposureConstants.SET_EXPOSURE_TYPE_PNNV, 'exposureTypePNNV')
export const setExposedTo = makeActionCreator(ExposureConstants.SET_EXPOSED_TO, 'exposedTo', 'crewId')
export const saveExposure = makeActionCreator(ExposureConstants.SAVE_EXPOSURE, 'data')
export const setExposureState = makeActionCreator(ExposureConstants.SET_EXPOSURE_STATE, 'exposureState')
export const resetExposure = makeActionCreator(ExposureConstants.RESET_STATE)
